import axios from "axios";
import { ACR, BASE_URL, GET_REMARKS, VIEW_JOB } from "../../constant/urls";

export const handlesnackCloseFail = (setsnackOpenfail) => {
    setsnackOpenfail(false);
    return false
};
export const handlesnackCloseSuccess = (setsnackopensucess) => {
    setsnackopensucess(false);
    return false

};
export const handleexchsau = (viewjobid, exchsau, exchange, params, setJobdetailstable) => {
    if (viewjobid) {
        if (exchsau === exchange ? viewjobid : null) {
            const url = `${BASE_URL}/${ACR}/${VIEW_JOB}?job_id=${viewjobid}`
            axios.get(url, { params: params })
                .then((res) => {
                    setJobdetailstable(res.data.Data);
                })
        }
    }
    return viewjobid
}
// using axios api calls api call for remarks table
export const handleRemarks = (job_id, params, setRemarksData, handleTable, setsnackOpenfail, setSnackmsg) => {
    const remarksurl = `${BASE_URL}/${ACR}/${GET_REMARKS}?job_id=${job_id}`
    axios.get(remarksurl, { params: params })
        .then((res) => {
            setRemarksData(res.data.Data);
            handleTable()
        })
        .catch((error) => {
            console.error(error);
            setsnackOpenfail(true);
            setSnackmsg("Something went wrong!.Please try again!")
        })
    return null
};

// open job
export const handleOpenJob = (setExchsau, setViewjobid, exchange, jobid) => {
    setExchsau(exchange);
    setViewjobid(jobid)
    return jobid
}

// functionality to disable on hold
export const holddisable = (jobdetailsdisable,jobdetailstable,tabledata) => {
    if (jobdetailsdisable) {
        return jobdetailsdisable
    }
    else if (jobdetailstable?.length === 0) {
        return true;
    }
    else if (jobdetailstable?.marked_as_onhold === false && jobdetailstable.marked_as_unviable === false) {
        return false
    }
    else {
        return tabledata[0]?.marked_as_unviable
    }
};
 // functionality to disable on viable
export const viabledisable = (jobdetailsdisable,jobdetailstable,tabledata) => {
    if (jobdetailsdisable) {
        return jobdetailsdisable
    }
    else if (jobdetailstable?.length === 0) {
        return true;
    }
    else if (jobdetailstable?.marked_as_onhold === false && jobdetailstable.marked_as_unviable === false) {
        return false
    }
    else {
        return tabledata[0]?.marked_as_onhold
    }
};

// functionality to disable on rolback
export const handleRollbackdisable = (jobdetailsdisable,disable,activeStep,viable,rollbackdisable) => {
    if (jobdetailsdisable) {
        return jobdetailsdisable
    }
    else if (disable) {
        return disable;
    }
    else if (activeStep > 3 && viable === false) {
        return true
    }
    else if (viable === true) {
        return false
    }
    else if (rollbackdisable) {
        return rollbackdisable
    }
}

// functionality to disable on move next
export const handleMoveNextdisable = (jobdetailsdisable,disable,viable,activeStep) => {
    if (jobdetailsdisable) {
        return jobdetailsdisable
    }
    else if (disable) {
        return disable;
    }
    else if (viable === true) {
        return true
    }
    else if (activeStep === 7) {
        return true
    }
}
 // axios call to add remarks
export  const handleAddRemarks = (jobid,viewjobid,remarks,USER_EIN,ADD_REMARKS,setRemarks,setsnackOpenfail,setSnackmsg,setsnackopensucess) => {
    const newremark = {
        "job_id": jobid || viewjobid,
        "remarks": remarks,
        "user_ein": USER_EIN
    }
    const postremarksurl = `${BASE_URL}/${ACR}/${ADD_REMARKS}`
    axios.post(postremarksurl, newremark,)
        .then((res) => {
            setRemarks('');
            (res.data.status).toLowerCase() === "fail" && (() => {
                setsnackOpenfail(true);
                setSnackmsg(res.data.MESSAGE);
            })();
            // if ((res.data.status).toLowerCase() === "fail") {
            //     setsnackOpenfail(true);
            //     setSnackmsg(res.data.MESSAGE);
            // }
            (res.data.status).toLowerCase() === "success" && (() => {
                setsnackopensucess(true);
                setSnackmsg("Remarks added successfully")
            })();
            //                 else if ((res.data.status).toLowerCase() === "success") {
            //     setsnackopensucess(true);
            //     setSnackmsg("Remarks added successfully")
            // }
        })
        .catch((error) => {
            // console.error(error);
            setsnackOpenfail(true);
            setSnackmsg("Something went wrong!.Please try again!")
        })

}
 // Rollback
    export const handleRollback = (ROLL_BACK,jobid,viewjobid,USER_EIN,setsnackOpenfail,setSnackmsg,setsnackopensucess,handleTable) => {
        const rollbackurl = `${BASE_URL}/${ACR}/${ROLL_BACK}?job_id=${jobid || viewjobid}&user_ein=${USER_EIN}`
        axios.delete(rollbackurl,)
            .then((res) => {
                (res.data.status).toLowerCase() === "fail" && (() => {
                    setsnackOpenfail(true);
                    setSnackmsg('Something went wrong!.Please try again!')
                })();
                (res.data.status).toLowerCase() === "success" && (() => {
                    setsnackopensucess(true);
                    setSnackmsg("Rollback done successfully")
                })();
                // else if ((res.data.status).toLowerCase() === "success") {
                //     setsnackopensucess(true);
                //     setSnackmsg("Rollback successfully")
                // }
                handleTable();
            })
            .catch((error) => {
                setsnackOpenfail(true);
                setSnackmsg("Something went wrong!.Please try again!")
            })
    };
    // functionality to handle next stage
export const handleNext = (setActiveStep,activeStep,steps,viewjobid,jobid,USER_EIN,NEXT_STAGE,overall_status,setRollbackdisable,setsnackOpenfail,setSnackmsg,handleTable) => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        const status = steps.find((item) => item.id === activeStep + 1);
        status && (() => {
            const next_stage = status.stage;
            const nextstage = {
                "job_id": jobid || viewjobid,
                "overall_status": next_stage,
                "user_ein": USER_EIN
            };
            const nextstageurl = `${BASE_URL}/${ACR}/${NEXT_STAGE}`;
            (overall_status?.id >= 4) && setRollbackdisable(true)
            axios.patch(nextstageurl, nextstage,)
                .then((res) => {
                    (res.data.status).toLowerCase() === "fail" && (() => {
                        setsnackOpenfail(true);
                        setSnackmsg(res.data.MESSAGE)
                    })()
                    // if ((res.data.status).toLowerCase() === "fail") {
                    //     setsnackOpenfail(true);
                    //     setSnackmsg(res.data.MESSAGE)
                    // }
                    handleTable();
                })
                .catch((error) => {
                    // console.error(error);
                    setsnackOpenfail(true);
                    setSnackmsg("Something went wrong!.Please try again!")
                })
        })()
    };
 // handle viable and unviable
   export const handleviable = (viable,setViable,jobid,viewjobid,USER_EIN,UNVIABLE,setsnackOpenfail,setSnackmsg,handleTable) => {
        setViable(viable);
        const newviable =
        {
            "job_id": jobid || viewjobid,
            "marked_as_unviable": viable,
            "user_ein": USER_EIN
        }
        const viableurl = `${BASE_URL}/${ACR}/${UNVIABLE}`;
        axios.patch(viableurl, newviable,)
            .then((res) => {
                if ((res.data.status).toLowerCase() === "fail") {
                    setsnackOpenfail(true);
                    setSnackmsg(res.data.MESSAGE)
                }
                handleTable()
            })
            .catch((error) => {
                // console.error(error);
                setsnackOpenfail(true);
                setSnackmsg("Something went wrong!.Please try again!")
            })
    }
    // handle hold and resume
        export const handlehold = (holds,setHold,jobid,viewjobid,USER_EIN,HOLD,setsnackOpenfail,setSnackmsg,handleTable) => {
            setHold(holds)
            const newhold =
            {
                "job_id": jobid || viewjobid,
                "marked_as_onhold": holds,
                "user_ein": USER_EIN
            }
    
            const holdurl = `${BASE_URL}/${ACR}/${HOLD}`;
            axios.patch(holdurl, newhold,)
                .then((res) => {
                    if ((res.data.status)?.toLowerCase() === "fail") {
                        setsnackOpenfail(true);
                        setSnackmsg(res.data.MESSAGE)
                    }
                    handleTable();
                })
                .catch((error) => {
                    // console.error(error);
                    setsnackOpenfail(true);
                    setSnackmsg("Something went wrong!.Please try again!")
                })
        }
// eslint-disable-next-line import/no-anonymous-default-export
export default { handlesnackCloseFail, handlesnackCloseSuccess, handleexchsau, handleOpenJob, holddisable,viabledisable,handleRollbackdisable }